const navigationData = [
    {
        linkName: 'Лікарі',
        href: '/doctors'
    },
    {
        linkName: 'Графік роботи',
        href: '/devision'
    },
    {
        linkName: 'Послуги',
        href: '/services'
    },
    {
        linkName: 'Новини',
        href: '/news'
    },
    {
        linkName: 'Про поліклініку',
        href: '/about-cliniс'
    },
    {
        linkName: 'Хочу знати',
        href: '/want-to-find'
    },
    {
        linkName: 'Потрібна допомога',
        href: '/help'
    },
    {
        linkName: 'Лікуватись',
        href: '/treatment'
    },
]

export default navigationData